<template>
  <div>
    <a
      v-if="typeof item == 'object' && (item.acf_format !== 'video' && item.acf_format !== 'image')"
      class="result"
      :href="item.acf_if_link ? item.modal : (item.is_document ? item.is_document : item.link)"
      :target="item.acf_if_link ? item.modal_target : (item.is_document ? '_blank' : '_self')"
    >
      <div class="image illust">
        <span
          v-if="item.acf_format && item.acf_format !== 'page'"
          :class="'icon-media-' + item.acf_format"
        >
          <svg><use :href="'#icon-media-' + item.acf_format"></use></svg>
        </span>
        <img :src="item.featured_media_url">
      </div>
      <div class="description">
        <div class="type">
          <template v-for="(value, key) in trad">
            <span
              :key="key"
              v-if="key == item.acf_format"
            > {{ value }}  </span>
          </template>
        </div>
        <h5
          class="title"
          v-if="item.title"
        >
          {{ item.title.rendered | truncate(200, "...") }}
        </h5>
        <span class="introduction">
          {{ item.acf_intro | truncate(250, "...") }}
        </span>
      </div>
    </a>
    <div
      v-else-if="typeof item == 'object' && item.acf_format === 'video'"
      class="result"
      @click="openModalVideo"
    >
      <div class="image illust">
        <span :class="'icon-media-' + item.acf_format">
          <svg><use :href="'#icon-media-' + item.acf_format"></use></svg>
        </span>
        <img :src="item.featured_media_url">
      </div>
      <div class="description">
        <div class="type">
          <template v-for="(value, key) in trad">
            <span
              :key="key"
              v-if="key == item.acf_format"
            > {{ value }}  </span>
          </template>
        </div>
        <h5
          class="title"
          v-if="item.title"
        >
          {{ item.title.rendered | truncate(200, "...") }}
        </h5>
        <span class="introduction">
          {{ item.acf_intro | truncate(250, "...") }}
        </span>
      </div>
    </div>
    <div
      v-else-if="typeof item == 'object' && item.acf_format === 'image'"
      class="result"
      @click="openModalImg"
    >
      <div class="image illust">
        <span :class="'icon-media-' + item.acf_format">
          <svg><use :href="'#icon-media-' + item.acf_format"></use></svg>
        </span>
        <img :src="item.featured_media_url">
      </div>
      <div class="description">
        <div class="type">
          <template v-for="(value, key) in trad">
            <span
              :key="key"
              v-if="key == item.acf_format"
            > {{ value }}  </span>
          </template>
        </div>
        <h5
          class="title"
          v-if="item.title"
        >
          {{ item.title.rendered | truncate(200, "...") }}
        </h5>
        <span class="introduction">
          {{ item.acf_intro | truncate(250, "...") }}
        </span>
      </div>
    </div>
    <modal-video-search
      v-if="activeModalVideo"
      @close-modal-video="closeModalVideo"
      :id-youtube="item.modal"
    />
    <modal-img-search
      v-if="activeModalImg"
      @close-modal-img="closeModalImg"
      :images="item.modal"
    />
  </div>
</template>

<script>
import ModalVideoSearch from './ModalVideoSearch';
import ModalImgSearch from './ModalImgSearch';

export default {
  components: {
    ModalVideoSearch,
    ModalImgSearch,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    assetUrl: {
      type: String,
      required: true,
    },
    trad: {
      type: [Array, Object],
      required: true,
    },
  },
  data() {
    return {
      activeModalVideo: false,
      activeModalImg: false,
    };
  },
  methods: {
    openModalVideo() {
      this.activeModalVideo = true;
      document.body.classList.add('modal-is-open');
    },
    closeModalVideo() {
      this.activeModalVideo = false;
      document.body.classList.remove('modal-is-open');
    },
    openModalImg() {
      this.activeModalImg = true;
      document.body.classList.add('modal-is-open');
    },
    closeModalImg() {
      this.activeModalImg = false;
      document.body.classList.remove('modal-is-open');
    },
  },
};
</script>

<style lang="scss" scoped></style>
